import { createSlice } from '@reduxjs/toolkit';

import {
  alternarStatusModeloCarta,
  atualizarModeloCarta,
  buscarModeloCarta,
  criarModeloCarta,
  listarModelosCarta,
} from './actions';
import type { ModeloCarta, ModelosCartaState } from '../types/modeloCartaTypes';

const initialState: ModelosCartaState = {
  modelos: [],
  isLoading: false,
  isSaving: false,
  error: null,
};

const upsert = (state: ModelosCartaState, modelo: ModeloCarta) => {
  const index = state.modelos.findIndex((item) => item.id === modelo.id);
  if (index !== -1) {
    state.modelos[index] = modelo;
  } else {
    state.modelos.push(modelo);
  }
};

const modelosCartaSlice = createSlice({
  name: 'modelosCarta',
  initialState,
  reducers: {
    clearModelosCartaError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(listarModelosCarta.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(listarModelosCarta.fulfilled, (state, action) => {
        state.isLoading = false;
        state.modelos = action.payload;
      })
      .addCase(listarModelosCarta.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload ?? 'Erro ao carregar os modelos.';
      })
      .addCase(buscarModeloCarta.fulfilled, (state, action) => {
        upsert(state, action.payload);
      })
      .addCase(buscarModeloCarta.rejected, (state, action) => {
        state.error = action.payload ?? 'Erro ao carregar o modelo.';
      })
      .addCase(criarModeloCarta.pending, (state) => {
        state.isSaving = true;
        state.error = null;
      })
      .addCase(criarModeloCarta.fulfilled, (state, action) => {
        state.isSaving = false;
        upsert(state, action.payload);
      })
      .addCase(criarModeloCarta.rejected, (state, action) => {
        state.isSaving = false;
        state.error = action.payload ?? 'Erro ao criar o modelo.';
      })
      .addCase(atualizarModeloCarta.pending, (state) => {
        state.isSaving = true;
        state.error = null;
      })
      .addCase(atualizarModeloCarta.fulfilled, (state, action) => {
        state.isSaving = false;
        upsert(state, action.payload);
      })
      .addCase(atualizarModeloCarta.rejected, (state, action) => {
        state.isSaving = false;
        state.error = action.payload ?? 'Erro ao salvar o modelo.';
      })
      .addCase(alternarStatusModeloCarta.fulfilled, (state, action) => {
        upsert(state, action.payload);
      })
      .addCase(alternarStatusModeloCarta.rejected, (state, action) => {
        state.error = action.payload ?? 'Erro ao atualizar o status.';
      });
  },
});

export const { clearModelosCartaError } = modelosCartaSlice.actions;

export default modelosCartaSlice.reducer;
